package com.yogaaicoach.pages.auth

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.yogaaicoach.pages.auth.firebase.FirebaseService
import com.yogaaicoach.pages.auth.firebase.createAccountPlatform
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.launch


class CreateAccountViewModel(private val firebaseService: FirebaseService) : ViewModel() {
    private val _email = MutableStateFlow("")
    val email: StateFlow<String> = _email

    private val _password = MutableStateFlow("")
    val password: StateFlow<String> = _password

    private val _confirmPassword = MutableStateFlow("")
    val confirmPassword: StateFlow<String> = _confirmPassword

    private val _error = MutableStateFlow("")
    val error: StateFlow<String> = _error

    private val _isLoading = MutableStateFlow(false)
    val isLoading: StateFlow<Boolean> = _isLoading

    fun onEmailChange(emailInput: String) {
        _email.value = emailInput
        _error.value = ""
    }

    fun onPasswordChange(passwordInput: String) {
        _password.value = passwordInput
        _error.value = ""
    }

    fun onConfirmPasswordChange(passwordInput: String) {
        _confirmPassword.value = passwordInput
        _error.value = ""
    }

    fun onError(errorMessage: String) {
        _error.value = errorMessage
    }

    fun createAccount(onSuccess: (email: String) -> Unit) {
        if (_password.value != _confirmPassword.value) {
            onError("Passwords do not match!")
            return
        }

        viewModelScope.launch {
            _isLoading.value = true
            val result = createAccountPlatform(_email.value, _password.value)
            _isLoading.value = false
            result.onSuccess { onSuccess(_email.value) }
            result.onFailure { err ->
                _error.value = firebaseService.mapErrorMessage(err)
            }
        }
    }
}
